import {createSimpleContext} from "../../../utils/context.tsx"
import {TSalesPlansFiltering} from "./utils.ts"

export const FilteringContext = createSimpleContext<TSalesPlansFiltering>("filtering")
